import script from "./ConfirmModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConfirmModal.vue?vue&type=script&lang=ts&setup=true"

import "./ConfirmModal.vue?vue&type=style&index=0&id=6fa44748&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fa44748"]])

export default __exports__